import {
  AccountsPayablePage,
  BidLogPage,
  CashflowPage,
  CompaniesPage,
  EstimateCategoriesPage,
  EstimateTemplatesPage,
  EstimatesPage,
  HomePage,
  JobsPage,
  OpportunitiesPage,
  PaymentsPage,
  ProfitAnalysisPage,
  RateSheetPage,
  TestPage,
  AdminPage,
  LookupsPage,
  CompanyRelationshipsPage,
  LabourRateClassesPage,
  ServiceAreasPage,
  ProjectsPage,
  RolesPage,
  ContactsPage
} from '~/pages';
import { BaseLayout } from '~/layouts';

export const routes = [
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: 'accounts-payable',
        element: <AccountsPayablePage />
      },
      {
        path: 'bid-log',
        element: <BidLogPage />
      },
      {
        path: 'cashflow',
        element: <CashflowPage />
      },
      {
        path: 'companies',
        element: <CompaniesPage />
      },
      {
        path: 'estimate-categories',
        element: <EstimateCategoriesPage />
      },
      {
        path: 'estimate-templates',
        element: <EstimateTemplatesPage />
      },
      {
        path: 'estimates',
        element: <EstimatesPage />
      },
      {
        path: '',
        element: <HomePage />
      },
      {
        path: 'jobs',
        element: <JobsPage />
      },
      {
        path: 'opportunities',
        element: <OpportunitiesPage />
      },
      {
        path: 'payments',
        element: <PaymentsPage />
      },
      {
        path: 'profit-analysis',
        element: <ProfitAnalysisPage />
      },
      {
        path: 'rate-sheet',
        element: <RateSheetPage />
      },
      {
        path: 'admin',
        element: <AdminPage />
      },
      {
        path: 'admin/lookups',
        element: <LookupsPage />
      },
      {
        path: 'admin/company-relationships',
        element: <CompanyRelationshipsPage />
      },
      {
        path: 'admin/labour-rate-classes',
        element: <LabourRateClassesPage />
      },
      {
        path: 'admin/service-areas',
        element: <ServiceAreasPage />
      },
      {
        path: 'admin/test-page',
        element: <TestPage />
      },
      {
        path: 'admin/projects',
        element: <ProjectsPage />
      },
      {
        path: 'admin/roles',
        element: <RolesPage />
      },
      {
        path: 'contacts',
        element: <ContactsPage />
      }
    ],
  },
];